export default {
  params: null,
};
